import { render, staticRenderFns } from "./dialog_tip.vue?vue&type=template&id=3e211e40&scoped=true&"
import script from "./dialog_tip.vue?vue&type=script&lang=js&"
export * from "./dialog_tip.vue?vue&type=script&lang=js&"
import style0 from "./dialog_tip.vue?vue&type=style&index=0&id=3e211e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e211e40",
  null
  
)

export default component.exports